export default {"src":"/_next/static/media/InternationalBrands.fae131e0.svg","height":302,"width":740,"blurWidth":0,"blurHeight":0};